"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WrapperTextArea = exports.TextArea = exports.CharactersInfo = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _palette = require("../../styles/palette");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var WrapperTextArea = exports.WrapperTextArea = _styledComponents["default"].div.withConfig({
  displayName: "styles__WrapperTextArea",
  componentId: "sc-s0ca0y-0"
})(["flex:1;position:relative;"]);
var CharactersInfo = exports.CharactersInfo = _styledComponents["default"].div.withConfig({
  displayName: "styles__CharactersInfo",
  componentId: "sc-s0ca0y-1"
})(["position:absolute;bottom:30px;right:10px;color:", ";"], _palette.commonPalette.textSecondary);
var TextArea = exports.TextArea = _styledComponents["default"].textarea.withConfig({
  displayName: "styles__TextArea",
  componentId: "sc-s0ca0y-2"
})(["color:", ";margin-bottom:20px;height:150px;resize:none;font-family:Lato;font-size:16px;padding:10px 15px;border:1px solid ", ";border-radius:3px;outline:none;width:100%;::placeholder,::-webkit-input-placeholder{color:", ";}:-ms-input-placeholder{color:", ";}&:focus{border:1px solid ", ";-webkit-box-shadow:0px 0px 3px 1px ", ";box-shadow:0px 0px 3px 1px ", ";}"], _palette.commonPalette.textPrimary, _palette.commonPalette.strokeDefault, _palette.commonPalette.textSecondary, _palette.commonPalette.textSecondary, _palette.commonPalette.sgGreen, _palette.commonPalette.sgGreen, _palette.commonPalette.sgGreen);
//# sourceMappingURL=styles.js.map